import { z } from "zod";

export const OverviewCart = z.object({
  cartGuid: z.string(),
  cartId: z.string(),
  storeGuid: z.string(),
  maintenanceLocation: z.string().nullish(),
  maintenanceNote: z.string().nullish(),
  isDisabled: z.boolean().nullish(),
  isMissing: z.boolean().nullish(),
  maintenanceMode: z.number().nullish(),
  desiredEnvironment: z.string().nullish(),
  lastBatteryCharge: z.number().nullish(),
  lastBatteryChargeOn: z.string().nullish(),
  lastBatteryChargingState1: z.string().nullish(),
  lastBatteryChargingState2: z.string().nullish(),
  location: z.string().nullish(),
  isGpsDisabled: z.boolean().nullish(),
  cartTicket: z.any().nullish(),
  hardwareRevision: z.string().nullish(),
  framenumber: z.string().nullish(),
  lastSeen: z.string().nullish(),
  isChargerConnected: z.boolean().nullish(),
  batteryLevel: z.string().nullish(),
});
export type OverviewCart = z.infer<typeof OverviewCart>;
